import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { Row, Col } from "react-bootstrap";

/* services */
import { GetStudentsForClass } from "../../api/class";

import ModalConfirmDelete from "../global/modals/ModalConfirmDelete";

const customStyles = {
  iconAdd: {
    alignContent: "center",
    fontSize: "17px",
    color: "var(--red-primary)",
  },
  iconAddDisabled: {
    alignContent: "center",
    fontSize: "17px",
    color: "var(--red-primary)",
    opacity: 0.5,
  },
  iconRemoveX: {
    alignContent: "center",
    fontSize: "17px",
    color: "#b8bcbd",
  },
  borderTopTbody: {
    borderTop: "1px solid gray",
  },
};

// dimensiones de la pantalla
const screenHeight = window.innerHeight;
const containerHeight = screenHeight - 232;

const StudentsForClass = (props) => {
  const [t] = useTranslation(["class", "global"]);

  const [disabledAddButton, setDisabledAddButton] = useState(true);
  const [studentList, setStudentList] = useState([]);
  const [loadingStudents, setLoadingStudents] = useState(false);
  const [studentsCount, setStudentsCount] = useState(0);
  const [showModalDelete, setShowModalDelete] = useState(false);
  const [studentToDelete, setStudentToDelete] = useState(null);

  useEffect(() => {
    const emptyObject = Object.keys(props.schoolingFilters || {}).length === 0;
    if (
      props.schoolingFilters &&
      props.schoolingFilters != "clean" &&
      !emptyObject
    ) {
      setDisabledAddButton(false);
      // si se selecciona todos los grupos no cargar nada, se añadira manualmente
      if (props.schoolingFilters.grade_level_id) {
        setStudentList([]);
        setStudentsCount(0);
        return;
      }

      getStudents();
    }
    if (props.schoolingFilters == "clean") {
      setStudentList([]);
      setStudentsCount(0);
      setDisabledAddButton(true);
    }
  }, [props.schoolingFilters]);

  useEffect(() => {
    props.setFieldStudents(studentList);
  }, [studentsCount]);

  useEffect(() => {
    if (props.newStudentsAdd.length === 0) return;
    const updatedStudentList = studentList.concat(props.newStudentsAdd);
    setStudentList(updatedStudentList);
    setStudentsCount(updatedStudentList.length);
    props.setStudentsCount(updatedStudentList.length);
    props.setNewStudentsAdd([]); // limpiar despues de usar
  }, [props.newStudentsAdd]);

  // detectado por efecto altered
  // toma el studentInclasss de props y lo muestra

  const getStudents = () => {
    setLoadingStudents(true);
    GetStudentsForClass(props.schoolingFilters)
      .then((response) => {
        if (response.status) {
          const data = response.data.filter(
            (student) =>
              student.status == "Activo" || student.status == "Active",
          );

          const scolarship = (student) => {
            let level = "";
            if (student.grade_level) {
              level = ` - ${student.grade_level} ` + student.group_name;
            } else {
              level = ` - ` + t("class:stundentsClass.higherLevel");
            }
            return level;
          };
          const students = data.map((student) => ({
            id: student.id,
            name:
              student.last_name +
              " " +
              student.first_name +
              " " +
              student.middle_name +
              scolarship(student),
          }));
          // ordenar alfabéticamente
          students.sort((a, b) => a.name.localeCompare(b.name));
          setStudentsCount(students.length);
          props.setStudentsCount(students.length);
          setStudentList(students);
          props.setFieldStudents(students);
        }
      })
      .catch(() => {})
      .finally(() => {
        setLoadingStudents(false);
      });
  };

  const removeStudent = () => {
    const updatedStudentList = studentList.filter(
      (student) => student.id !== studentToDelete,
    );
    setStudentList(updatedStudentList);
    setStudentsCount(updatedStudentList.length);
    props.setStudentsCount(updatedStudentList.length);
  };

  return (
    <>
      <Row>
        {/* crear tabla con dos columnas */}
        <Col md={12} style={{ maxHeight: containerHeight, overflowY: "auto" }}>
          <table className="table table-bordered student-table-bordered">
            <thead>
              <tr>
                <th
                  style={{
                    position: "sticky",
                    top: 0,
                    background: "#fff",
                    zIndex: 2,
                  }}
                >
                  {t("class:stundentsClass.studentName")}

                  <i
                    className="bi bi-plus-circle-fill float-end"
                    style={
                      disabledAddButton
                        ? customStyles.iconAddDisabled
                        : customStyles.iconAdd
                    }
                    id="addStudent"
                    role="button"
                    onClick={() => {
                      disabledAddButton
                        ? null
                        : props.setShowModalAddStudents(true);
                    }}
                  ></i>
                </th>
              </tr>
            </thead>
            <tbody style={customStyles.borderTopTbody}>
              {loadingStudents &&
                [1, 2, 3, 4, 5].map((item, index) => (
                  <>
                    <tr key={index}>
                      <td>
                        <div
                          className="table-lazyLoading"
                          style={{ display: "flex" }}
                        >
                          <Col md={6}>
                            <div style={{ height: "21px", width: "60%" }}></div>
                          </Col>
                          <Col md={6}>
                            <div
                              className="float-end"
                              style={{ height: "21px", width: "10%" }}
                            ></div>
                          </Col>
                        </div>
                      </td>
                    </tr>
                  </>
                ))}
              {!loadingStudents &&
                studentList.map((student, index) => (
                  <tr key={index}>
                    <td>
                      {student.name}
                      <i
                        className="bi bi-x-circle-fill float-end"
                        style={customStyles.iconRemoveX}
                        id={"removeStudent-" + index}
                        role="button"
                        onClick={() => {
                          setShowModalDelete(true);
                          setStudentToDelete(student.id);
                        }}
                      />
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
        </Col>
      </Row>
      {showModalDelete && (
        <ModalConfirmDelete
          showModalDelete={showModalDelete}
          title={t("class:stundentsClass.deleteStudent")}
          message={t("class:stundentsClass.deleteStudentMessage")}
          fnCancelButton={() => {
            setShowModalDelete(false);
            setStudentToDelete(null);
          }}
          fnAcceptButton={() => {
            removeStudent();
            setShowModalDelete(false);
          }}
        />
      )}
    </>
  );
};

export default StudentsForClass;

StudentsForClass.propTypes = {
  classId: PropTypes.string,
  schoolingFilters: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  setFieldStudents: PropTypes.func,
  setShowModalAddStudents: PropTypes.func,
  newStudentsAdd: PropTypes.array,
  setNewStudentsAdd: PropTypes.func,
  setStudentsCount: PropTypes.func,
};
